import { createRoute } from "@tanstack/react-router";

import { teamRoute } from "../../platform/routes";
import { TokensScreen } from "./TokensScreen";

export const tokensRoute = createRoute({
  getParentRoute: () => teamRoute,
  path: "tokens",
  component: TokensScreen,
});
